import Api from '@/api/api';
import apiCommonUrl from '@/api/apiCommonUrl'
// import vehicleTypeDB from "@/temp/vehicleTypeJsonVals";

export default {
    getVehicleTypesbyTenant() {
        return Api.get('Vendor/Vehicle/GetVehicleTypesOfTenant');
    },
    getAllVehicleTypes() {
        return apiCommonUrl.get('SaasAdmin/VehicleType/GetVehicleType')
    },
    removeVehicleType(id) {
        return Api.delete(`/api/VehicleType/DeleteVehicle/${id}`);
    },
    addVehicleTypes(vehicleType) {
        return Api.post('/api/VehicleType/AddVehicleType', vehicleType);
    },
    updateVehicleTypes(id, data) {
        return Api.put(`/api/VehicleType/UpdateVehicleType/${id}`, data);
    }
}